import ApiHelper from '@/utils/api-helper'
import API from '@/constants/api'

class ArticleService {
  static getArticles(limit = 10, page = 1) {
    return ApiHelper.fetch(`${API.URL + API.ARTICLES}?pageSize=${limit}&page=${page}`)
  }

  static getArticle(slug) {
    return ApiHelper.fetch(`${API.URL + API.ARTICLES}/${slug}`)
  }

  static updateArticle(article) {
    if (typeof article._id === 'undefined') {
      return this.addArticle(article)
    }

    return ApiHelper.fetch(`${API.URL + API.ARTICLES}/${article['_id']}`, {
      method: 'PUT',
      body: JSON.stringify({
        article
      })
    })
  }

  static addArticle(article) {
    return ApiHelper.fetch(`${API.URL + API.ARTICLES}`, {
      method: 'POST',
      body: JSON.stringify({
        article
      })
    })
  }

  static deleteArticle(id) {
    return ApiHelper.fetch(`${API.URL + API.ARTICLES}/${id}`, {
      method: 'DELETE'
    })
  }
}

export default ArticleService
